import { serverGet, serverPost } from "lib/serverRequest";

export const getCouponcodes = ({ onFinish = () => {} }) => {
  serverGet({ url: `couponcode`, onFinish: onFinish });
};

export const getCouponcode = ({ id = "", onFinish = () => {} }) => {
  serverGet({ url: `couponcode/${id}`, onFinish: onFinish });
};

export const createCoupon = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `couponcode/create`,
    data: data,
    onFinish: onFinish,
  });
};

export const updateCoupon = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `couponcode/update`,
    data: data,
    onFinish: onFinish,
  });
};

export const deleteCoupon = ({ id = "", onFinish = () => {} }) => {
  serverGet({ url: `couponcode/delete/${id}`, onFinish: onFinish });
};
